export default __webpack_public_path__ + "static/Floorplan_PH4AR-LL_v1-bd5d08b54d52953564d9423a0d76662d.svg";